import { Button, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

function SessionTimeoutModal({ show, remainingSeconds, onStaySignedIn }) {
  const formatTime = seconds => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins > 0) {
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    }
    return `${secs} second${secs !== 1 ? 's' : ''}`;
  };

  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      onHide={() => {}}
    >
      <Modal.Header className="modal-header bg-warning-subtle">
        <Modal.Title className="modal-header-title d-flex align-items-center">
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className="text-warning me-2"
          />
          Session Timeout Warning
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        <div className="text-center">
          <p className="fs-1 fw-bold text-danger mb-3">
            {formatTime(remainingSeconds)}
          </p>
          <p className="mb-0">
            You will be automatically logged out due to inactivity.
          </p>
          <p className="text-muted">
            Click "Stay Signed In" to continue your session.
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button
          variant="primary"
          size="lg"
          onClick={onStaySignedIn}
          className="px-5"
        >
          Stay Signed In
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

SessionTimeoutModal.propTypes = {
  show: PropTypes.bool.isRequired,
  remainingSeconds: PropTypes.number.isRequired,
  onStaySignedIn: PropTypes.func.isRequired
};

export default SessionTimeoutModal;
